module.exports = __webpack_public_path__ + "img/checklist.3ae4bb37.svg";